/*@flow*/
import { useState, useEffect } from 'react';
import * as db from 'lib/db';
import downloadURL from 'lib/downloadURL';
import qs from 'qs';
import api from 'lib/api';
import * as log from 'lib/log';

function getJobFromLocalStorage() {
  const value = db.read('__job_id__');
  return value === 'undefined' || value === 'null' ? null : value;
}

function useJobIdSync(downloadJobId) {
  useEffect(() => {
    db.write('__job_id__', downloadJobId);
  }, [downloadJobId]);
}

export default function useDownload(): {|
  clearErrors: () => void,
  downloadErrors: Array<string>,
  isLoading: boolean,
  scheduleDownload: (query: { ... }) => void,
|} {
  const [downloadJobId, setDownloadJobId] = useState(getJobFromLocalStorage);
  const [errors, setError] = useState([]);

  useJobIdSync(downloadJobId);

  useEffect(() => {
    errors.length > 0 && log.error(errors);
  }, [errors]);

  useEffect(() => {
    if (!downloadJobId) return;

    function startDownload(res) {
      setError([]);
      const payload = JSON.parse(res.message || {});
      const { paths, filenames } = payload;

      if (paths.length > 0) {
        paths.forEach((path, i) => {
          const fileName = filenames[i];
          const url = `/tables/download_file?filename=${fileName}&path=${path}`;
          downloadURL({ fileName, url });
        });
      } else {
        setError(['Nothing to download.']);
      }

      setDownloadJobId(null);
    }

    function showErrors(res) {
      setError(res.errors);
      setDownloadJobId(null);
    }

    function checkProgress() {
      api
        .fetch('/tables/job_progress', { query: { job_id: downloadJobId } })
        .then((res) => res.json())
        .then((res) => {
          if (res.status === 'Success') {
            startDownload(res);
          } else if (status === 'FileError') {
            setDownloadJobId(null);
            showErrors(res);
          }
        })
        .catch((err) => {
          showErrors({ errors: [err] });
        });
    }

    const id = setInterval(checkProgress, 1000);
    return () => clearInterval(id);
  }, [downloadJobId]);

  function scheduleDownload(query: {}) {
    const str = qs.stringify(query);
    const url = `/tables/download/query_background?${str}`;
    api
      .fetch(url)
      .then((res) => res.json())
      .then((payload) => {
        setDownloadJobId(payload.job_id);
      });
  }

  const isLoading = Boolean(downloadJobId);

  function clearErrors() {
    setError([]);
  }

  return { scheduleDownload, downloadErrors: errors, isLoading, clearErrors };
}
